export default __webpack_public_path__ + "static/media/hero-image2.31256917.PNG";